import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './NavBar.css';
import image_logo from './Assets/new_image_logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faUserCog } from '@fortawesome/free-solid-svg-icons';

const NavBar = ({ user, onLogout }) => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const profileDropdownRef = useRef(null);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);

  const handleLogout = () => {
    onLogout();
    localStorage.removeItem('fullName');
    localStorage.removeItem('email');
    localStorage.removeItem('userId');
    localStorage.removeItem('token');
    localStorage.removeItem('profilePictureUrl');
    navigate('/login');
  };

  const profilePicture = localStorage.getItem('profilePictureUrl');
  const userId = localStorage.getItem('userId');
  const fullName = localStorage.getItem('fullName');
  const firstLetter = fullName ? fullName.charAt(0).toUpperCase() : '';

  const toggleProfileDropdown = () => {
    setShowProfileDropdown(!showProfileDropdown);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const handleClickprofile = () => {
    navigate('/profile');
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        closeMobileMenu();
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const getProfileImage = () => {
    if (profilePicture && profilePicture !== 'null' && profilePicture !== '') {
      return profilePicture;
    }
    return firstLetter;
  };
  return (
    <>
      <nav className="navbar">
        <div className="menu-icon" onClick={toggleMobileMenu}>☰</div>
        <div className="nav-logo">
          <Link to="/">
            <img src={image_logo} alt="nav-logo" className="nav-logoo" />
          </Link>
        </div>
        <div className="navbar-links">
          {userId ? (
            <>
              <div className="profile-container" ref={profileDropdownRef}>
                <Link to="/manage-jobs" className="nav-link">Manage Jobs
                </Link>

                {profilePicture && profilePicture !== 'null' && profilePicture !== '' ? (
                  <img src={getProfileImage()} alt="profile" className="profile-image" />
                ) : (
                  <p className="profile-image" onClick={toggleProfileDropdown}>
                    {getProfileImage()}
                  </p>
                )}

                <div className={`profile-dropdown ${showProfileDropdown ? 'show' : ''}`}>
                  <div className="profile-dropdown-item" onClick={() => navigate('/profile')}>
                    <FontAwesomeIcon icon={faUserCog} /> AccountSettings
                  </div>
                  
                  <div className="profile-dropdown-item" onClick={handleLogout}>
                    <FontAwesomeIcon icon={faSignOutAlt} /> Signout
                  </div>
                </div>
              </div>
            </>
          ) : (
            <Link to="/login">Login</Link>
          )}
        </div>
      </nav>
      <div className={`overlay ${isMobileMenuOpen ? 'show' : 'hide'}`} onClick={closeMobileMenu}></div>
      <div className={`main-mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="close-menu" onClick={closeMobileMenu}>✖</div>
        <div className="mobile-links">
          {userId ? (
            <>
              <div className="profile-container" ref={profileDropdownRef}>
                {profilePicture && profilePicture !== 'null' && profilePicture !== '' ?
                  <img src={getProfileImage()} alt='profile' className="profile-image" /> :
                  <p className="profile-image" onClick={toggleProfileDropdown}>{firstLetter}</p>
                }

                <div className={`profile-dropdown ${showProfileDropdown ? 'show' : ''}`}>
                  <div className="profile-dropdown-item" onClick={handleClickprofile}>
                    <FontAwesomeIcon icon={faUserCog} /> AccountSettings
                  </div>

                  <div className="profile-dropdown-item" onClick={handleLogout}>
                    <FontAwesomeIcon icon={faSignOutAlt} /> Signout
                  </div>
                </div>
              </div>
            </>
          ) : (
            <Link to="/login" onClick={closeMobileMenu}>Login</Link>
          )}
        </div>
    <Link to="/manage-jobs"  className="nav-link">Manage Jobs
                    </Link>  
      </div>
    </>
  );
};

export default NavBar;
